export default __webpack_public_path__ + "static/media/telegram.fdd61e98.svg";